<template>
  <div>
      <ed-audiometro  :key="$root.$session.versao" :intId="this.$route.params.intId"/>
  </div>
</template>

<script>
import EdAudiometro from "@/components/audiometria/audiometro/editar";
export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: { EdAudiometro },
  mounted() {
    if (!this.$route.params.intId) {
      this.$router.push({ name: "audiometria.audiometro" });
    }
  },
  created() {},
  data() {
    return {};
  },
  methods: {},
};
</script>